import { render, staticRenderFns } from "./BerkasTable.vue?vue&type=template&id=c0976a6e&"
import script from "./BerkasTable.vue?vue&type=script&lang=js&"
export * from "./BerkasTable.vue?vue&type=script&lang=js&"
import style0 from "./BerkasTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports